package org.gymly.api.dto

import kotlinx.serialization.Serializable

@Serializable
data class PasswordRecoveryStatusDto(val available: Boolean)

@Serializable
data class PasswordRecoveryRequestDto(val scope: String, val email: String)

@Serializable
data class PasswordRecoveryConfirmDto(
    val scope: String,
    val email: String,
    val code: String,
    val newPassword: String,
)

@Serializable
data class PasswordRecoveryMessageDto(val message: String)

/** Tienda con pasarela: la URL a la que vuelve el socio después de pagar (solo http/https). */
@Serializable
data class PortalStoreCheckoutLinkRequestDto(val returnUrl: String)

@Serializable
data class PortalStoreCheckoutLinkDto(val url: String)
